<template>
    <div>
        <div v-if="!black">
            <nav
                class="main-header navbar navbar-expand bg-white navbar-light border-bottom"
            >
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a data-widget="pushmenu" href="#" class="nav-link">
                            <i class="fa fa-bars"></i>
                        </a>
                    </li>
                </ul>
                <b>{{ name_system }}</b>
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item dropdown user-menu">
                        <a
                            class="btn btn-default btn-flat float-right btn-block"
                            href="#"
                        >
                            {{ user.nombre }} {{ user.apellido }}
                        </a>
                    </li>
                    <li class="nav-item dropdown user-menu">
                        <a
                            class="btn btn-default btn-flat float-right btn-block"
                            :href="$root.UrlBase('logout')"
                        >
                            <i class="fa fa-fw fa-power-off text-red"></i> Log
                            Out
                        </a>
                    </li>
                </ul>
            </nav>

            <aside class="main-sidebar sidebar-dark-primary elevation-4">
                <router-link :to="{ name: 'Inicio' }" class="brand-link">
                    <center>
                        <img
                            :src="$root.UrlBase('img/logo.png')"
                            alt="text"
                            class="full-logo"
                            style="width: 80%"
                        />
                        <img
                            :src="$root.UrlBase('img/iso-logo.png')"
                            alt="text"
                            class="iso-logo"
                            style="width: 80%"
                        />
                    </center>
                </router-link>

                <div class="sidebar">
                    <nav class="pt-2">
                        <ul
                            class="nav nav-pills nav-sidebar flex-column"
                            data-widget="treeview"
                            role="menu"
                            data-animation-speed="300"
                            data-accordion="true"
                        >
                            <li
                                v-for="(element, key) in menu"
                                v-bind:key="key"
                                class="nav-item"
                            >
                                <a
                                    href="javascript:void(0)"
                                    class="nav-link"
                                    v-if="element.submenu.length !== 0"
                                >
                                    <i class="far fa-fw fa-circle"> </i>

                                    <p>
                                        {{ element.descripcion }}
                                        <i class="right fas fa-angle-left"></i>
                                    </p>
                                </a>
                                <ul class="nav nav-treeview">
                                    <li
                                        v-for="(
                                            sElement, skey
                                        ) in element.submenu"
                                        v-bind:key="skey"
                                        class="nav-item tercer-nivel"
                                    >
                                        <a
                                            href="javascript:void(0)"
                                            class="nav-link"
                                            style="padding-left: 20px"
                                        >
                                            <i
                                                class="far fa-circle nav-icon"
                                            ></i>
                                            <p>
                                                {{ sElement.descripcion }}
                                                <i
                                                    class="right fas fa-angle-left"
                                                ></i>
                                            </p>
                                        </a>
                                        <ul class="nav nav-treeview">
                                            <li
                                                v-for="(
                                                    ssElement, sskey
                                                ) in sElement.submenu"
                                                v-bind:key="sskey"
                                                class="nav-item"
                                            >
                                                <a
                                                    href="javascript:void(0)"
                                                    v-on:click="
                                                        changeIframe(
                                                            ssElement.rutina
                                                        )
                                                    "
                                                    class="nav-link"
                                                    style="padding-left: 40px"
                                                >
                                                    <i
                                                        class="far fa-fw fa-circle nav-icon"
                                                    ></i>
                                                    <p>
                                                        {{
                                                            ssElement.descripcion
                                                        }}
                                                    </p>
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </nav>
                </div>
            </aside>
        </div>

        <div
            class="content-wrapper"
            :style="{ marginLeft: black ? '0px' : '' }"
        >
            <iframe
                v-if="pantallaIframe"
                :src="pantallaIframe"
                frameborder="0"
                height="100%"
                :style="
                    'overflow: hidden;height: 100%;width: 98%;position: absolute;inset: 0px;left: 2%;' +
                    'display:' +
                    displayIframe
                "
            ></iframe>
            <transition
                name="slide-fade"
                mode="out-in"
                v-if="pantallaIframe === false"
            >
                <router-view
                    :key="$route.fullPath"
                    :request="request"
                ></router-view>
            </transition>
        </div>

        <footer class="main-footer"></footer>
    </div>
</template>

<script type="text/javascript">
import { mapState } from "vuex";
import { mapMutations } from "vuex";

export default {
    props: ["menu", "user", "request2", "configuration", "black"],
    data() {
        return {
            pantallaIframe: false,
            height: "0px",
            width: "0px",
            padding: "20px",
            displayIframe: "initial",
        };
    },
    computed: {
        ...mapState(["request"]),
    },
    methods: {
        changeIframe(frame) {
            console.log(frame);
            if (frame.includes("/")) {
                this.$router.push(
                    process.env.MIX_APP_PATH +
                        "/" +
                        frame +
                        "?" +
                        this.getRandomInt(1000)
                );
                this.height = "0vh";
                this.width = "0%";
                this.pantallaIframe = false;
                this.displayIframe = "none";
            } else if (!frame.includes(".php")) {
                this.$router.push({
                    name: frame,
                    params: { q: this.getRandomInt(1000), NC: "RE" },
                });
                this.height = "0vh";
                this.width = "0%";
                this.pantallaIframe = false;
                this.displayIframe = "none";
            } else {
                this.displayIframe = "initial";

                this.$router.push({
                    name: "Inicio",
                    params: { q: this.getRandomInt(1000), NC: "RE" },
                });
                this.pantallaIframe = false;

                if (frame.substr(-4) === ".php") {
                    this.pantallaIframe =
                        process.env.MIX_APP_PATH +
                        "/" +
                        frame +
                        "?" +
                        this.getRandomInt(1000);
                } else {
                    this.pantallaIframe =
                        process.env.MIX_APP_PATH +
                        "/" +
                        frame +
                        "&" +
                        this.getRandomInt(1000);
                }
                this.height = "90vh";
                this.width = "100%";
            }
        },
        getRandomInt(max) {
            return Math.floor(Math.random() * max);
        },
        ...mapMutations({ requestSet: "request" }),
    },
    created() {
        if (this.black) {
        }

        this.name_system = process.env.MIX_NAME_SYSTEM;

        this.requestSet(this.request2);
    },
};
</script>
